import { createIconComponent } from '../../factory/create-icon-component';
export const ShareIcon = createIconComponent(
  'ShareIcon',
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15 6.5L8 9.5M15 17.5L8 14M18.25 8.75C16.5932 8.75 15.25 7.40685 15.25 5.75C15.25 4.09315 16.5932 2.75 18.25 2.75C19.9069 2.75 21.25 4.09315 21.25 5.75C21.25 7.40685 19.9069 8.75 18.25 8.75ZM5.25003 14.75C3.59318 14.75 2.25003 13.4069 2.25003 11.75C2.25003 10.0931 3.59318 8.75 5.25003 8.75C6.90688 8.75 8.25003 10.0931 8.25003 11.75C8.25003 13.4069 6.90688 14.75 5.25003 14.75ZM18.25 20.75C16.5932 20.75 15.25 19.4069 15.25 17.75C15.25 16.0931 16.5932 14.75 18.25 14.75C19.9069 14.75 21.25 16.0931 21.25 17.75C21.25 19.4069 19.9069 20.75 18.25 20.75Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>,
);
